export default {"src":"/_next/static/media/icone_cosmesi1.20c36899.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};